import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { Button } from '@material-ui/core';
import React, { useCallback } from 'react';
import { Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { BaseText } from '..';
import { ClearVehicleType } from '../../store/ducks/vehicleType/action';
import './styles.scss';
import Typography from '../atoms/typography';
import ButtonComponent from '../atoms/button';

interface MyProps {
  name: string;
  navigationPath?: string;
}

const RowHeaderTable: React.FC<MyProps> = ({
  name,
  navigationPath,
}: MyProps) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const onNavigationClick = useCallback(
    (path: string) => {
      if (path === '/home/vehicle-types/create') {
        dispatch(ClearVehicleType());
      }
      history.push(path);
    },
    [history, dispatch],
  );

  return (
    <Row className="header" noGutters>
      <Typography fontWeight="700" fontSize="default" color="secondary">
        {name}
      </Typography>
      {navigationPath && (
        <div style={{ justifyContent: 'flex-end' }}>
          <ButtonComponent
            theme="primary"
            onClick={() => onNavigationClick(navigationPath)}
          >
            <FontAwesomeIcon icon={solid('plus')} size="sm" color="#fff" /> Novo
          </ButtonComponent>
        </div>
      )}
    </Row>
  );
};

export default RowHeaderTable;
